import React, { useState, useEffect, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import URL from '@pages/index/common/URL';
import util from '../../entries/common/util';

import './index.less';

const { formatTimestamp } = util;

const App = () => {
  const [article, setArticle] = useState({});
  const articleRef = useRef();

  useEffect(() => {
    const id = getQuery('id');
    getArticle(id);
  }, []);

  const getQuery = (key) => {
    const queries = window.location.search.substring(1);
    const values = queries.split('&');
    for (let i = 0; i < values.length; i++) {
      const param = values[i].split('=');
      if (param[0] == key) {
        return param[1];
      }
    }
    return false;
  };
  const getArticle = async (id) => {
    await fetch(
      `${window.location.protocol}//${window.location.host}${URL.GET_ARTICLE}/${id}`
    )
      .then(async (result) => {
        const contentType = result.headers.get("Content-Type");
        if (contentType && contentType.includes("application/json")) {
          return result.json();
        } else {
          const res = await result.text()
          throw new Error(res);
        }
      })
      .then((data) => {
        if (data?.code !== 0) {
          throw data;
        }
        setArticle(data.data);
        const node = document
          .createRange()
          .createContextualFragment(data.data.content);
        articleRef.current.appendChild(node);
      })
      .catch((e) => {
        console.log(e);
        setArticle({});
      });
  };

  return (
    <div className="container">
      <div className="market-news-details-box">
        <div className="market-news-details-section-inner">
          <img
            src={article.thumbnail}
            className="market-news-details-thumbnail"
          />
          <div className="market-news-details-ex">
            <div className="market-news-details-ex-author">
              {article.author}
            </div>
            <div className="market-news-details-ex-publish-time">
              <img
                style={{ verticalAlign: 'top', transform: 'translateY(4px)' }}
                src={`${window.okGlobal.cdnBaseUrl}/cdn/assets/imgs/market/clock.svg`}
              />
              <span style={{ verticalAlign: 'top', marginLeft: '5px' }}>
                {formatTimestamp(article.publishTime, 'YYYY/MM/dd')}
              </span>
            </div>
          </div>
          <div className="market-news-details-title">{article.title}</div>
          <div className="content">
            <div ref={articleRef} />
          </div>
        </div>
        <div className="market-news-details-back-to-list">
          <div
            className="market-news-details-back-to-list-container"
            onClick={() => {
              window.location.href = '/markets/news';
            }}
          >
            マーケットニュース一覧へ
          </div>
        </div>
        <div className="market-no-responsible">
          <div className="market-no-responsible-container">
            <div className="market-no-responsible-title">免責条項</div>
            {article.source === 'Coin Choice' && (
              <div className="market-no-responsible-content">
                <p>
                  マーケットニュースにおいてお客様に提供される情報は、
                  <a href="https://coinchoice.net/">Coin Choice</a>
                  が収集・作成等したものです。
                </p>
                <p>
                  当社は、お客様への情報提供を目的として本情報を提供するものであり、暗号資産取引の勧誘を目的とするものではありません。暗号資産取引等に関する意思決定は、お客様ご自身の判断と責任でなさるようお願いいたします。
                </p>
                <p>
                  本情報には他のサイトへのリンクが含まれる場合、更に第三者が運営する外部サービスに遷移する場合がありますが、お客様が外部サービスで行った行動について、当社は一切の責任を負いません。お客様が外部サービスを利用する際には、法令及び外部サービスが定める規則に従ってください。
                </p>
                <p>
                  本情報の著作権は、Coin Choice
                  その他の権利者に帰属します。本情報の全部又は一部の販売、転用その他法令等により認められる方法以外での利用は固く禁じられております。
                </p>
                <p>
                  本情報は信頼性が高いと思われる情報に基づき作成されておりますが、当社及びCoin
                  Choice
                  はその完全性、正確性その他の一切の事項を保証いたしません。
                </p>
                <p>
                  本情報に関連してお客様または第三者に損害が生じた場合において、当社は一切の責任を負いません。
                </p>
              </div>
            )}
            {(article.source === 'Crypto Times' || !article.source) && (
              <div className="market-no-responsible-content">
                <p>
                  マーケットニュースにおいてお客様に提供される情報は、
                  <a href="https://crypto-times.jp/">Crypto Times</a>
                  を運営する
                  <a href="https://rokubunnoni.com/">株式会社ロクブンノニ</a>
                  が収集・作成等したものです。
                </p>
                <p>
                  当社は、お客様への情報提供を目的として本情報を提供するものであり、暗号資産取引の勧誘を目的とするものではありません。暗号資産取引等に関する意思決定は、お客様ご自身の判断と責任でなさるようお願いいたします。
                </p>
                <p>
                  本情報には他のサイトへのリンクが含まれる場合、更に第三者が運営する外部サービスに遷移する場合がありますが、お客様が外部サービスで行った行動について、当社は一切の責任を負いません。お客様が外部サービスを利用する際には、法令及び外部サービスが定める規則に従ってください。
                </p>
                <p>
                  本情報の著作権は、株式会社ロクブンノニ（Crypto
                  Times）その他の権利者に帰属します。本情報の全部又は一部の販売、転用その他法令等により認められる方法以外での利用は固く禁じられております。
                </p>
                <p>
                  本情報は信頼性が高いと思われる情報に基づき作成されておりますが、当社及び株式会社ロクブンノニ（Crypto
                  Times）はその完全性、正確性その他の一切の事項を保証いたしません。
                </p>
                <p>
                  本情報に関連してお客様または第三者に損害が生じた場合において、当社は一切の責任を負いません。
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const root = createRoot(document.getElementById('root'));
root.render(<App />);
